import React, { useState, useEffect, useMemo } from 'react';
import { FlatList, Platform, ScrollView, SectionList, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Icon as SvgIcon } from '../../../../../components/Icon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';
import Header from '../../../../../navigation/Header';
import dayjs from 'dayjs';
import PaymentDetailModal from '../Fees/Payments/PaymentDetailModal';


export const currency = (value, withDecimalsOnZero=true) => `${value ? value?.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) : '-'}`


export default function UnitBalanceScreen({ navigation, route }) {
  const { communityId, unitId } = route.params
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [shownPaymentId, setShownPaymentId] = useState();

  const { isInitialLoading, error, data: reportOverview, refetch } = useQuery({
    queryKey: ['community.unit.fees.balance', communityId, unitId],
    queryFn: () => api.get(`/communities/${communityId}/units/${unitId}/fees/balance`).then(response => response.data),
  })


  const activationDate = reportOverview?.activation_date ? dayjs(reportOverview.activation_date) : null


  function downloadBalancePDF(){
    downloadFile(`/communities/${communityId}/units/${unitId}/fees/balance/pdf`)
  }

  async function downloadFile(path) {
    const filename = `reporte-${reportOverview?.unit?.name}.pdf`

    try {
      setDownloadingPdf(true)

      const response = await api.get(path, {
        responseType: 'blob',
        timeout: 30000,
      });

      setDownloadingPdf(false)

      if (response.data instanceof Blob) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.log(typeof response.data)
        throw new Error('La respuesta no es un Blob.');
      }
    } catch (error) {
      setDownloadingPdf(false)

      console.error('Error descargando el PDF:', error);
    }
  }


  return (
    <View style={tw`flex-1 bg-background`}>
      <Header style={`mb-0 bg-secondary rounded-b-none`} showBackButton backButtonColor='white'>
        <View style={tw`flex-1`}>

          <View style={tw`row justify-between`}>
            <View style={tw`row`}>
              {/* <Icon name='time' color={tw.color('white')} style={tw``} size={20} /> */}
              {/* <Image source={require('../../../../assets/images/icons/cobros-filled.svg')} style={tw`h-8 w-8 mr-1 -ml-2`} /> */}

              <Text style={tw`text-xl font-600 text-white`}>Estado de cuenta</Text>
              {/* <Text style={tw`ml-3 text-xl font-600 text-white`}>{categorizedFees?.last_monthly?.name ?? "Cuota mensual"}</Text> */}
            </View>


            {
              Platform.OS === "web" &&
                <TouchableOpacity
                  style={tw.style(`row items-center bg-white rounded-full px-4 h-10`, downloadingPdf && `opacity-50`)}
                  onPress={downloadBalancePDF}
                  disabled={downloadingPdf}
                >
                  <View style={{ transform: [{ rotate: '90deg' }] }}>
                    <SvgIcon
                      name='rightArrowCircle'
                      size={14}
                      color={tw.color('secondary')}
                    />
                  </View>
                  <Text style={tw`text-secondary font-600 ml-2`}>Descargar PDF</Text>
                </TouchableOpacity>
            }

           
          </View>
        </View>
      </Header>

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-4 py-6`}>
    

        {/* <View style={tw`px-5 py-3 border-b bg-gray-100 rounded-xl border-gray-300`}>
          <Text>Mes: Enero</Text>
          <Text>Total de ingresos: { currency(reportOverview?.income_total) }</Text>
          <Text>Total de gastos: { currency(reportOverview?.expenses_total) }</Text>
          <Text>Ingresos - Gastos: <Text style={tw.style(reportOverview?.balance_total < 0 && `text-red`)}>{ currency(reportOverview?.balance_total) }</Text></Text>
        </View> */}

        <View style={tw`px-5 py-4 bg-[#F9FAFB] rounded-2xl border border-gray-200 mb-4`}>
          <Text style={tw`font-600 text-xl text-secondary mb-2`}>{reportOverview?.unit?.name}</Text>

          <View style={tw`row justify-between`}>
            <Text>Activación:</Text>
            <Text>{activationDate ? activationDate.format('DD MMMM YYYY') : '-'}</Text>
          </View>

          <View style={tw`row justify-between`}>
            <Text>Meses activo:</Text>
            <Text>{reportOverview?.active_months ?? '-'}</Text>
          </View>

          <View style={tw`row justify-between`}>
            <Text>Cuotas cubiertas:</Text>
            <Text>{reportOverview?.charged_main_fees ?? '-'}</Text>
          </View>

          <View style={tw`row justify-between`}>
            <Text>Cuotas vencidas:</Text>
            <Text>{reportOverview?.pending_main_fees ?? '-'}</Text>
          </View>

          <View style={tw`row justify-between`}>
            <Text>Aportación vencida:</Text>
            <Text>{currency(reportOverview?.pending_main_fees_amount) }</Text>
          </View>

          {/* <View style={tw`row justify-between`}>
            <Text>Fondo de reserva:</Text>
            <Text>{ currency(reportOverview?.expenses_total) }</Text>
          </View> */}

          {
            reportOverview?.other_fees?.map(fee => 
              <View style={tw`row justify-between`} key={fee.uuid}>
                <Text>{fee.fee.name}:</Text>

                <Text>{currency(fee.pending)}</Text>
              </View>
            )
          }


          <View style={tw`row justify-between`}>
            <Text>Total Adeudo:</Text>

            <Text>{currency(reportOverview?.total_pending_amount) }</Text>
          </View>

          {/* <Text>Activación: 27-jun-09</Text>
          <Text>Total de ingresos: { currency(reportOverview?.income_total) }</Text>
          <Text>Total de gastos: { currency(reportOverview?.expenses_total) }</Text>
          <Text>Ingresos - Gastos: <Text style={tw.style(reportOverview?.balance_total < 0 && `text-red`)}>{ currency(reportOverview?.balance_total) }</Text></Text> */}
        </View>


        {
          isInitialLoading &&
            <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
        }


        <View style={tw``}>
          {
            reportOverview?.payments?.map(payment => {
              const paymentDate = payment?.apply_date ? dayjs(payment.apply_date) : null

              return (
                <TouchableOpacity
                  style={tw`bg-white rounded-2xl border border-gray-200 py-3 px-4 mb-3`}
                  key={payment.uuid}
                  onPress={() => setShownPaymentId(payment.uuid)}
                >
                  <View style={tw`row justify-between`} key={payment.uuid}>
                    <Text style={tw`font-600 text-secondary`}>#{payment.folio}</Text>

                    <Text style={tw`font-600 text-secondary`}>{currency(payment.amount)}</Text>
                  </View>

                  <View style={tw`row`}>
                    <Text style={tw`text-gray-500`}>{payment.payment_method?.name}</Text>
                    <Text style={tw`mx-1`}>-</Text>
                    <Text style={tw`text-gray-500`}>{paymentDate ? paymentDate.format('DD/MM/YYYY') : '-'}</Text>
                  </View>

                  {
                    payment.fee_units?.map(fee_unit =>
                      <View style={tw`row justify-between`} key={fee_unit.uuid}>
                        <Text>{fee_unit.fee.name}</Text>
        
                        {/* <Text>{currency(fee_unit.amount)}</Text> */}
                      </View>
                    )
                  }
                </TouchableOpacity>
              )
            })
          }
        </View>

  {/* 
        <View style={tw`px-5 py-4`}>
          <View style={tw`mb-5`}>
            <Text style={tw`font-500 text-lg`}>Ingresos</Text>

            <View style={tw`row justify-between`}>
              <Text>Mantenimiento</Text>
              <Text style={tw`text-gray-600`}>{ currency(reportOverview?.incomes_by_category?.main) }</Text>
            </View>

            <View style={tw`row justify-between`}>
              <Text>Otros ingresos</Text>
              <Text style={tw`text-gray-600`}>{ currency(reportOverview?.incomes_by_category?.other) }</Text>
            </View>

            <View style={tw`row justify-between`}>
              <Text>Suma de ingresos</Text>
              <Text style={tw`font-600 border-t border-gray-400 pl-4`}>{currency(reportOverview?.income_total)}</Text>
            </View>
          </View>
          

          <View style={tw`mb-5`}>
            <Text style={tw`font-500 text-lg`}>Gastos</Text>

    
            {
              reportOverview?.expenses_by_category?.map(item =>
                <View style={tw`row justify-between`} key={item.name}>
                  <Text>{item.name}</Text>
                  <Text style={tw`text-gray-600`}>{currency(item.total)}</Text>
                </View>
              )
            }

            <View style={tw`row justify-between`}>
              <Text>Suma de gastos</Text>
              <Text style={tw`font-600 border-t border-gray-400 pl-4`}>{ currency(reportOverview?.expenses_total) }</Text>
            </View>
          </View>
        </View> */}

        
      </ScrollView>

      {
        shownPaymentId &&
          <PaymentDetailModal
            onRequestClose={() => setShownPaymentId()}
            paymentId={shownPaymentId}
            onPaymentEdited={refetch}
            onPaymentDeleted={() => {
              setShownPaymentId()
              refetch()
            }}
          />
      }
    </View>
  )
}